import logo from './logo-mcr.svg';

export const settings = {
    "title": "Genius Store",
    "apiUrl": "https://api.mcrarredi.geniuscloud.it/api",
    "ckdPath": "https://api.mcrarredi.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'MCR Arredi Srl',
        "address": 'Via Sempione, 45B/C - 20015 Parabiago MI',
        "phone": 'Tel: 0331 1520844',
        "fax": '',
        "email": 'Email: info@stosaparabiago.it',
        "iva": 'P.IVA: 11188140963',
        "cf": 'C.F.: 11188140963',
        "website": 'Sito Web: www.stosaparabiago.it',
    },
    "dati_pagamento": {
        "iban": "",
        "bic": "",
        "banca": "",
        "intestatario": "",
    },
    "dati_fattura": {
        "statoPIVA": "IT",
        "PIVA": "03490440264",
        "PIVAcompleta": "IT03490440264",
        "regimeFiscale": "RF04",
        "numeroREA": "",
        "socioUnico": "SU",
        "statoLiquidazione": "LN",
        "ufficio": "",
        "indirizzo": "Corte delle Rose, 8",
        "cap": "31015",
        "comune": "Conegliano",
        "nazione": "IT",
        "provincia": "TV",
        "formatoTrasmissione": "FPR12",
        "codiceDestinatario": "A4707H7",
        "denominazione": "Prelude Advertising",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": true
}